import { NewUser } from '../user/new-user';

export interface LendItem {
  id?: string;
  newUser?: NewUser;
}
